import { render, staticRenderFns } from "./deviceShipments.vue?vue&type=template&id=add42f08&scoped=true"
import script from "./deviceShipments.vue?vue&type=script&lang=js"
export * from "./deviceShipments.vue?vue&type=script&lang=js"
import style0 from "./deviceShipments.vue?vue&type=style&index=0&id=add42f08&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add42f08",
  null
  
)

export default component.exports